export default __webpack_public_path__ + "images/J2.a1bdd59.png";